import React, { useEffect, useState, useContext } from 'react';
import Alert from '../alert/Alert';
import SubmitButton, { InsufficientButton } from './SubmitButton';
import SlippageSelector from './SlippageSelector';

import { WalletContext } from '../../utils/wallets-integration';
import { SWAP_MODE, SwapProContext } from '../../pages/SwapPage';
import { useMyOrders } from '../../state/swapV3';
import { PoolInfo } from 'src/services/swapV3';
import { INEAR_USDT_SWAP_TODOS } from '../../stores/swapStore';
import { EstimateSwapView } from '../../services/swapTypes';

interface SwapFormWrapProps {
  title?: string;
  buttonText?: string;
  canSubmit?: boolean;
  slippageTolerance: number;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  info?: string | JSX.Element;
  showElseView?: boolean;
  swapTab?: JSX.Element;
  elseView?: JSX.Element;
  crossSwap?: boolean;
  requested?: boolean;
  tokensTitle?: JSX.Element;
  onChange: (slippage: number) => void;
  quoteDoneLimit?: boolean;
  selectTodos?: EstimateSwapView[];
  setReEstimateTrigger?: (trigger?: any) => void;
  loading?: {
    loadingData: boolean;
    setLoadingData: (loading: boolean) => void;
    loadingTrigger: boolean;
    setLoadingTrigger: (nextLoadingTrigger: boolean) => void;
    loadingPause: boolean;
    setLoadingPause: (pause: boolean) => void;
    showSwapLoading: boolean;
    setShowSwapLoading: (swapLoading: boolean) => void;
  };
  useNearBalance: string;
  swapMode?: SWAP_MODE;
  supportLedger?: boolean;
  setSupportLedger?: (supportLedger?: any) => void;
  showAllResults?: boolean;
  reserves?: JSX.Element;
  wrapOperation?: boolean;
  isInsufficient?: boolean;
  mostPoolDetail?: PoolInfo;
  near_usdt_swapTodos?: INEAR_USDT_SWAP_TODOS;
}

export default function SwapFormWrap({
  children,
  title,
  buttonText,
  slippageTolerance,
  canSubmit,
  onSubmit,
  info: infoContent,
  showElseView,
  elseView,
  onChange,
  swapTab,
  loading,
  swapMode,
  setReEstimateTrigger,
  supportLedger,
  setSupportLedger,
  quoteDoneLimit,
  isInsufficient,
  mostPoolDetail,
  near_usdt_swapTodos,
}: React.PropsWithChildren<SwapFormWrapProps>) {
  const [error, setError] = useState<Error>();

  const { activeOrder } = useMyOrders();
  const [viewPoolHover, setViewPoolHover] = useState(false);

  const { selectMarket } = useContext(SwapProContext);

  const {
    loadingTrigger,
    setLoadingPause,
    showSwapLoading,
    setShowSwapLoading,
  } = loading || {};

  useEffect(() => {
    loadingTrigger && setShowSwapLoading && setShowSwapLoading(true);
    !loadingTrigger && setShowSwapLoading && setShowSwapLoading(false);
  }, [loadingTrigger]);

  const { globalState } = useContext(WalletContext);
  const isSignedIn = globalState.isSignedIn;

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setError(null);

    if (isSignedIn) {
      try {
        if (near_usdt_swapTodos) {
          setLoadingPause(true);
        } else {
          setShowSwapLoading && setShowSwapLoading(true);

          setLoadingPause && setLoadingPause(true);
        }
        onSubmit(event);
      } catch (submitError) {
        setError(submitError);
      }
    }
  };

  return (
    <form
      className="overflow-y-visible relative overflow-x-visible"
      onSubmit={handleSubmit}
      noValidate
    >
      {title && (
        <>
          <h2 className="formTitle relative z-50 flex items-center justify-end text-sm font-normal text-primaryText pb-3">
            {swapTab}
            {swapMode === SWAP_MODE.NORMAL && (
              <SlippageSelector
                slippageTolerance={slippageTolerance}
                onChange={onChange}
                supportLedger={supportLedger}
                setSupportLedger={setSupportLedger}
                validSlippageList={null}
                swapMode={swapMode}
              />
            )}
          </h2>
        </>
      )}
      {error && <Alert level="warn" message={error.message} />}
      {children}
      {showElseView && elseView ? (
        elseView
      ) : (
        <div className="flex flex-col items-center">
          {!isInsufficient ? (
            <div
              className={`text-xs relative w-full ${
                swapMode === SWAP_MODE.LIMIT ? 'mt-6' : 'mt-4'
              }  `}
            >
              {' '}
              <SubmitButton
                disabled={
                  !canSubmit ||
                  (swapMode === SWAP_MODE.LIMIT
                    ? !quoteDoneLimit || (showSwapLoading && !loadingTrigger)
                    : showSwapLoading)
                }
                label={buttonText || title}
                info={infoContent}
                className={`h-12 ${
                  swapMode == SWAP_MODE.NORMAL ? '-mt-0' : ''
                }`}
                loading={
                  swapMode !== SWAP_MODE.LIMIT
                    ? showSwapLoading
                    : !quoteDoneLimit || (showSwapLoading && !loadingTrigger)
                }
              />
            </div>
          ) : (
            <InsufficientButton divClassName="h-12 mt-2 w-full"></InsufficientButton>
          )}
        </div>
      )}
    </form>
  );
}
